<template>
  <div
    v-show="showcaseItems.length > 0"
    class="kft-simple-card-showcase__container"
  >
    <div class="my-0 mx-auto">
      <div
        class="kft-simple-card-showcase__simple-cards-container flex flex-wrap flex-md-nowrap justify-content-between"
      >
        <template
          v-for="(item, i) in showcaseItems"
          :key="`kft-simple-card-showcase-card-${i}`"
        >
          <component
            :is="Boolean(item.link) && shouldWrapWithLink ? 'Link' : 'div'"
            :link="item.link"
            class="kft-simple-card-showcase__simple-card-container"
          >
            <SimpleCard
              :class="['kft-simple-card-showcase__simple-card', cardClass]"
              :description="item.description || ''"
              :image="item.imageUrl"
              :image-height="$device.isMobile ? '50px' : '250px'"
              :image-width="$device.isMobile ? '50px' : '300px'"
              :style="{ '--index': i }"
              :title="item.title || 'simple-category-showcase'"
              :link="item.link"
              :link-text="item.linkText"
              :use-native-anchor="useNativeAnchor"
              :circle-content="item.circleContent"
            />
          </component>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showcaseItems: {
      type: Array,
      default: () => [],
    },
    showNumber: {
      type: Boolean,
      default: false,
    },
    shouldWrapWithLink: {
      type: Boolean,
      default: false,
    },
    cardClass: {
      type: String,
      default: '',
    },
    useNativeAnchor: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="css" scoped>
.kft-simple-card-showcase__simple-cards-container {
  column-gap: var(--kft-simple-card-showcase-column-gap, 2rem);
  row-gap: var(--kft-simple-card-showcase-column-gap, 2rem);
}

.kft-simple-card-showcase__simple-card {
  width: 100%;
}

.kft-simple-card-showcase__simple-card-container,
.kft-simple-card-showcase__simple-card-container a {
  display: flex;
}

@media (min-width: 576px) {
  .kft-simple-card-showcase__simple-card-container,
  .kft-simple-card-showcase__simple-card {
    flex: 1;
  }
}

@media (min-width: 576px) and (max-width: 991px) {
  .kft-simple-card-showcase__simple-card-container,
  .kft-simple-card-showcase__simple-card {
    width: 200px;
  }
}

.kft-simple-card-showcase--small-title .kft-simple-card {
  --kft-simple-card-title-font-size: 1.143rem;
  --kft-brush-stroke-button-font-weight: var(--font-weight--semibold);
}

@media (min-width: 992px) {
  .kft-simple-card-showcase--small-title .kft-simple-card {
    --kft-simple-card-title-font-size: var(--h6-font-size);
  }
}

.kft-simple-card-showcase--large-gap {
  --kft-simple-card-showcase-column-gap: var(--spacer-20);
}
</style>
